// extracted by mini-css-extract-plugin
export default {"tabsContainer":"tabs_tabsContainer__Fl85-","headerTab":"tabs_headerTab__E8JSm","tab":"tabs_tab__nU-3Q","text":"tabs_text__isdg8"};